import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { AppStateType } from '../../reducers'
import { selectCapability } from '../../selectors/capabilities'
import { selectPublishingLocations } from '../../selectors/publishingLocations'
import { selectActiveModal } from '../../selectors/modal'
import { selectAreaWritable } from '../../selectors/auth'
import { AREA_CONSTANTS } from '../../services/auth'
import { CapabilitySettingsPage as Component } from './CapabilitySettingsPage'

const mapStateToProps = (state: AppStateType) => ({
  capability: selectCapability(state),
  publishingLocations: selectPublishingLocations(state),
  activeModal: selectActiveModal(state),
  editable: selectAreaWritable(state, { area: AREA_CONSTANTS.SETTINGS_CAPABILITY }),
})

export const CapabilitySettingsPage = withRouter(connect(mapStateToProps)(Component))
